"use strict";

var Ajv = require('ajv');

var documentStructureSchema_0_2_1 = require('./schema/structure/0_2_1/document_structure.json');

var sequenceStructureSchema_0_2_1 = require('./schema/structure/0_2_1/sequence_structure.json');

var blockStructureSchema_0_2_1 = require('./schema/structure/0_2_1/block_structure.json');

var contentElementStructureSchema_0_2_1 = require('./schema/structure/0_2_1/contentElement_structure.json');

var perfDocumentConstraintSchema_0_2_1 = require('./schema/constraint/0_2_1/perf_document_constraint.json');

var perfSequenceConstraintSchema_0_2_1 = require('./schema/constraint/0_2_1/perf_sequence_constraint.json');

var perfBlockConstraintSchema_0_2_1 = require('./schema/constraint/0_2_1/perf_block_constraint.json');

var perfContentElementConstraintSchema_0_2_1 = require('./schema/constraint/0_2_1/perf_contentElement_constraint.json');

var sofriaDocumentConstraintSchema_0_2_1 = require('./schema/constraint/0_2_1/sofria_document_constraint.json');

var sofriaSequenceConstraintSchema_0_2_1 = require('./schema/constraint/0_2_1/sofria_sequence_constraint.json');

var sofriaBlockConstraintSchema_0_2_1 = require('./schema/constraint/0_2_1/sofria_block_constraint.json');

var sofriaContentElementConstraintSchema_0_2_1 = require('./schema/constraint/0_2_1/sofria_contentElement_constraint.json');

class Validator {
  constructor() {
    this.schema = {
      structure: {},
      constraint: {}
    };

    for (var [key, schemaOb] of [['document', {
      "0.2.1": [{
        "name": "Document Structure",
        "validator": new Ajv().addSchema(contentElementStructureSchema_0_2_1).addSchema(blockStructureSchema_0_2_1).addSchema(sequenceStructureSchema_0_2_1).compile(documentStructureSchema_0_2_1)
      }]
    }], ['sequence', {
      "0.2.1": [{
        "name": "Sequence Structure",
        "validator": new Ajv().addSchema(contentElementStructureSchema_0_2_1).addSchema(blockStructureSchema_0_2_1).compile(sequenceStructureSchema_0_2_1)
      }]
    }]]) {
      this.schema.structure[key] = schemaOb;
    }

    for (var [_key, _schemaOb] of [['perfDocument', {
      "0.2.1": [{
        "name": "Document Structure",
        "validator": new Ajv().addSchema(contentElementStructureSchema_0_2_1).addSchema(blockStructureSchema_0_2_1).addSchema(sequenceStructureSchema_0_2_1).compile(documentStructureSchema_0_2_1)
      }, {
        "name": "PERF Document",
        "validator": new Ajv().addSchema(perfContentElementConstraintSchema_0_2_1).addSchema(perfBlockConstraintSchema_0_2_1).addSchema(perfSequenceConstraintSchema_0_2_1).compile(perfDocumentConstraintSchema_0_2_1)
      }]
    }], ['perfSequence', {
      "0.2.1": [{
        "name": "Sequence Structure",
        "validator": new Ajv().addSchema(contentElementStructureSchema_0_2_1).addSchema(blockStructureSchema_0_2_1).compile(sequenceStructureSchema_0_2_1)
      }, {
        "name": "PERF Sequence",
        "validator": new Ajv().addSchema(perfContentElementConstraintSchema_0_2_1).addSchema(perfBlockConstraintSchema_0_2_1).compile(perfSequenceConstraintSchema_0_2_1)
      }]
    }], ['sofriaDocument', {
      "0.2.1": [{
        "name": "Document Structure",
        "validator": new Ajv().addSchema(contentElementStructureSchema_0_2_1).addSchema(blockStructureSchema_0_2_1).addSchema(sequenceStructureSchema_0_2_1).compile(documentStructureSchema_0_2_1)
      }, {
        "name": "SOFRIA Document",
        "validator": new Ajv().addSchema(sofriaContentElementConstraintSchema_0_2_1).addSchema(sofriaBlockConstraintSchema_0_2_1).addSchema(sofriaSequenceConstraintSchema_0_2_1).compile(sofriaDocumentConstraintSchema_0_2_1)
      }]
    }], ['sofriaSequence', {
      "0.2.1": [{
        "name": "Sequence Structure",
        "validator": new Ajv().addSchema(contentElementStructureSchema_0_2_1).addSchema(blockStructureSchema_0_2_1).compile(sequenceStructureSchema_0_2_1)
      }, {
        "name": "SOFRIA Sequence",
        "validator": new Ajv().addSchema(sofriaContentElementConstraintSchema_0_2_1).addSchema(sofriaBlockConstraintSchema_0_2_1).compile(sofriaSequenceConstraintSchema_0_2_1)
      }]
    }]]) {
      this.schema.constraint[_key] = _schemaOb;
    }
  }

  schemaInfo() {
    var ret = {};

    for (var [schemaType, schemas] of Object.entries(this.schema)) {
      ret[schemaType] = {};

      for (var [schemaLabel, schemaVersions] of Object.entries(schemas)) {
        ret[schemaType][schemaLabel] = {};

        for (var [version, versionSteps] of Object.entries(schemaVersions)) {
          ret[schemaType][schemaLabel][version] = versionSteps.map(vs => vs.name);
        }
      }
    }

    return ret;
  }

  validate(schemaType, schemaKey, schemaVersion, data) {
    if (!data) {
      throw new Error("Usage: validate(schemaType, schemaKey, schemaVersion, data)");
    }

    if (!["structure", "constraint"].includes(schemaType)) {
      throw new Error("Schema type must be 'structure' or 'constraint' not '".concat(schemaType, "'"));
    }

    if (!this.schema[schemaType][schemaKey]) {
      throw new Error("Unknown ".concat(schemaType, " schema key ").concat(schemaKey));
    }

    if (!this.schema[schemaType][schemaKey][schemaVersion]) {
      throw new Error("Unknown version ".concat(schemaVersion, " for ").concat(schemaType, " schema key ").concat(schemaKey));
    }

    var validators = this.schema[schemaType][schemaKey][schemaVersion];
    var result;

    for (var {
      name: validatorName,
      validator
    } of validators) {
      result = {
        validatorName,
        isValid: validator(data),
        errors: validator.errors
      };

      if (!result.isValid) {
        break;
      }
    }

    return {
      requested: {
        schemaType,
        schemaKey,
        schemaVersion
      },
      lastSchema: result.validatorName,
      isValid: result.isValid,
      errors: result.errors
    };
  }

}

module.exports = Validator;